module.exports = __webpack_public_path__ + "static/media/welcome-stone.e24fdcd7.png";